import { useEffect, useRef, useState, useCallback } from "react"
import "../styles/home.css"
import "../styles/blogs.css"

/* ---------------- BLOG SLIDES ---------------- */

const blogSlides = [
  {
    lines: [
      "The easiest journey is the one that takes us outward, to achievements, possessions, and recognition.",
      "But the most challenging and transformative journey is inward, into the vast universe within.",
      "Why is it so hard?",
      "Because most of us are carrying unfelt emotions like sadness, anxiety, guilt, pain, hurt.",
      "Instead of facing and healing them, we lock them away in our hearts.",
      "When we live only from the mind, we lose connection with the Divine.",
      "God is not in the mind, God is in the heart.",
      "It’s time to pause. Feel. Heal. Return home.",
    ],
  },
  {
    lines: [
      "Blog 2.",
    ],
  },
]

export default function Blogs() {
  const scrollRef = useRef(null)
  const intervalRef = useRef(null)
  const [activeIndex, setActiveIndex] = useState(0)

  /* ---------- SCROLL TO SLIDE ---------- */
  const scrollToIndex = useCallback((index) => {
    const container = scrollRef.current
    if (!container) return

    const slideWidth = container.offsetWidth

    container.scrollTo({
      left: slideWidth * index,
      behavior: "smooth",
    })

    setActiveIndex(index)
  }, [])

  /* ---------- AUTO SCROLL ---------- */
  useEffect(() => {
    if (blogSlides.length <= 1) return

    intervalRef.current = setInterval(() => {
      setActiveIndex((prev) => {
        const next = (prev + 1) % blogSlides.length
        scrollToIndex(next)
        return next
      })
    }, 5000)

    return () => clearInterval(intervalRef.current)
  }, [scrollToIndex])

  return (
    <main className="blogs-root">
      <h1 className="blogs-title">Blogs</h1>

      <section
        className="home-horizontal-scroll"
        ref={scrollRef}
      >
        <div className="home-scroll-track">
          {blogSlides.map((slide, i) => (
            <div className="home-intro" key={i}>
              <div className="home-container text-only">
                <div className="home-text">
  {slide.lines.join("\n")}
</div>

              </div>
            </div>
          ))}
        </div>
      </section>

      {/* DOTS */}
      <div className="home-dots">
        {blogSlides.map((_, i) => (
          <span
            key={i}
            className={`dot ${activeIndex === i ? "active" : ""}`}
            onClick={() => scrollToIndex(i)}
          />
        ))}
      </div>
    </main>
  )
}
